// extracted by mini-css-extract-plugin
export default {"Logo":"Footer_Logo__LJ2KZ","footer":"Footer_footer__K6RKf","footerContent":"Footer_footerContent__o+bH8","contact":"Footer_contact__JwQlB"};